<template>
    <div class="content_wrap">
        <div class="wrap">
            <div class="password_main">
                <div class="password_main_top ft24">
                    <span class="second_font">修改发票</span>
                </div>
                <div class="invoiceChange">
                    <a-form :form="form" @submit="handleSubmit" v-bind="formItemLayout">
                        <a-form-item v-bind="formItemLayout" label="发票号码">
                            <a-input placeholder="请输入发票号码" v-decorator="[
                        'invoiceNumber'
                    ]" />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="发票代码">
                            <a-input placeholder="请输入发票代码" v-decorator="[
                        'invoiceCode'
                    ]" />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="开票日期">
                            <a-date-picker placeholder="请选择开票日期" v-decorator="[
                        'billingDate',
                    ]" />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="开票金额">
                            <a-input placeholder="请输入开票金额" v-decorator="[
                        'totalAmount',
                    ]" />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="发票状态">
                            <a-select v-decorator="[
                        'status',
                    ]" placeholder="请选择发票状态">
                                <a-select-option v-for="(item, index) in statusEnum" :key="index" :value="index">
                                    {{ item }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="销售方名称">
                            <a-input placeholder="请输入销售方名称" v-decorator="[
                        'sellerName',

                    ]" />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="销售方税号">
                            <a-input placeholder="请输入销售方税号" v-decorator="[
                        'sellerTaxNo',

                    ]" />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="购买方名称">
                            <a-input placeholder="请输入购买方名称" v-decorator="[
                        'buyerName',

                    ]" />
                        </a-form-item>
                        <a-form-item v-bind="formItemLayout" label="购买方税号">
                            <a-input placeholder="请输入购买方税号" v-decorator="[
                        'buyerTaxNo',
                    ]" />
                        </a-form-item>
                        <a-form-item v-bind="tailFormItemLayout">
                            <a-button @click="handleCancel()" class="mr10">
                                取消
                            </a-button>
                            <a-button type="primary" html-type="submit" class="ml10">
                                确定
                            </a-button>
                        </a-form-item>
                    </a-form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import moment from 'moment'

export default {
    data() {
        return {
            confirmDirty: false,
            autoCompleteResult: [],
            formItemLayout: {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 5 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 18 },
                },
            },
            tailFormItemLayout: {
                wrapperCol: {
                    xs: {
                        span: 24,
                        offset: 0,
                    },
                    sm: {
                        span: 16,
                        offset: 8,
                    },
                },
            },
            statusEnum: {
                0: '正常',
                1: '失控',
                2: '作废',
                3: '红冲',
                4: '异常',
                7: '部分红冲',
                8: '全额红冲'
            }
        };
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'changeInvoice' });
    },
    methods: {
        handleSubmit(e) {
            let that = this
            e.preventDefault();
            this.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    let params = {}
                    for (const key in values) {
                        if(key === 'billingDate') {
                            params[key] = values[key] ? moment(values[key]).format('YYYY-MM-DD') : ''
                            continue
                        }
                        if (!(values[key] && values[key].trim())) {
                            params[key] = ''
                        } else {
                            params[key] = values[key].trim()
                        }
                    }
                    that.http.post('/ystOpenPlatformBff/invoice/check/util/updateInvoice', params, res => {
                        if(res.success) {
                            that.$message.success('操作成功！')
                            that.form.resetFields()
                        } else {
                            that.$message.warning(res.message)
                        }
                    })
                }
            });
        },
        handleCancel() {
            this.$router.push('/developCenter/invoiceCheck')
        },
    },
};
</script>

<style>
.invoiceChange {
    padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/page/InvoiceChange.vue